import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import patientService from "../../../../../services/patient.service";

import { useEyeconxStore } from "../../../../../store/eyeconxStore";

function Overview({ patient }) {
  const [isEditing, setIsEditing] = useState(false);
const clinicId = useEyeconxStore((state) => state.user.clinicId);
const stripPhoneFormatting = (value) =>
  value ? value.replace(/\D/g, "") : value;

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { isDirty }
  } = useForm();

  const formValues = watch();

  useEffect(() => {
    if (!isEditing && patient) {
      reset({
        email: patient.email,
        cellNumber: patient.cellNumber,
        phoneNumber: patient.phoneNumber,
        isActive: patient.isActive
      });
    }
  }, [patient, isEditing, reset]);

  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return null;
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleEdit = () => {
    reset({
      email: patient.email,
      cellNumber: patient.cellNumber,
      phoneNumber: patient.phoneNumber,
      isActive: patient.isActive
    });
    setIsEditing(true);
  };

  const handleCancel = () => {
    reset({
      email: patient.email,
      cellNumber: patient.cellNumber,
      phoneNumber: patient.phoneNumber,
      isActive: patient.isActive
    });
    setIsEditing(false);
  };

  const onSubmit = async (data) => {
     const payload = {
    ...data,
    cellNumber: stripPhoneFormatting(data.cellNumber),
    phoneNumber: stripPhoneFormatting(data.phoneNumber)
  };
    await patientService.updatePatientDetails(clinicId,patient.id, payload);
    setIsEditing(false);
  };

  return (
    <>
      {/* Header */}
      <div className="d-flex justify-content-end mb-2">
        {!isEditing ? (
          <button className="btn btn-outline-primary" onClick={handleEdit}>
            Edit
          </button>
        ) : (
          <div className="d-flex gap-2">
            <button className="btn btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="btn btn-primary text-white"
              disabled={!isDirty}
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </button>
          </div>
        )}
      </div>

      {/* Names + Status */}
      <div className="row mb-3">
        <div className="col-md-5">
          <h6 className="text-muted mb-1">First Name</h6>
          <p className="mb-3 bg-light p-2 rounded">{patient?.firstName}</p>
        </div>

        <div className="col-md-5">
          <h6 className="text-muted mb-1">Last Name</h6>
          <p className="mb-3 bg-light p-2 rounded">{patient?.lastName}</p>
        </div>

        <div className="col-md-2">
          {isEditing ? (
            <div className="form-check form-switch mt-2">
              <input
                className="form-check-input"
                type="checkbox"
                {...register("isActive")}
              />
              <label className="form-check-label ms-2">Active</label>
            </div>
          ) : (
            <div
              className={`alert ${
                patient?.isActive ? "alert-success" : "alert-secondary"
              } d-flex align-items-center justify-content-between border-0 shadow-sm`}
            >
              <span className="fw-semibold">
                {patient?.isActive ? "Active" : "Not Active"}
              </span>
              <i
                className={`bi ${
                  patient?.isActive ? "bi-check-circle" : "bi-x-circle"
                } fs-5`}
              ></i>
            </div>
          )}
        </div>
      </div>

      {/* DOB / Age / Gender */}
      <div className="row mb-3">
        <div className="col-md-4">
          <h6 className="text-muted mb-1">Birth Date</h6>
          <p className="mb-3 bg-light p-2 rounded">{patient?.dateOfBirth}</p>
        </div>

        <div className="col-md-4">
          <h6 className="text-muted mb-1">Age (years)</h6>
          <p className="mb-3 bg-light p-2 rounded">
            {calculateAge(patient?.dateOfBirth)}
          </p>
        </div>

        <div className="col-md-4">
          <h6 className="text-muted mb-1">Gender</h6>
          <p className="mb-3 bg-light p-2 rounded">{patient?.gender}</p>
        </div>
      </div>

      {/* Editable Contact Info */}
      <div className="row mb-3">
        <div className="col-md-4">
          <h6 className="text-muted mb-1">Email</h6>
          {isEditing ? (
            <input
              type="email"
              className="form-control"
              {...register("email")}
            />
          ) : (
            <p className="mb-3 bg-light p-2 rounded">{patient?.email}</p>
          )}
        </div>

        <div className="col-md-4">
          <h6 className="text-muted mb-1">Cell Number</h6>
          {isEditing ? (
            <input
              type="tel"
              className="form-control"
              {...register("cellNumber")}
            />
          ) : (
            <p className="mb-3 bg-light p-2 rounded">
              {patient?.cellNumber}
            </p>
          )}
        </div>

        <div className="col-md-4">
          <h6 className="text-muted mb-1">Phone Number</h6>
          {isEditing ? (
            <input
              type="tel"
              className="form-control"
              {...register("phoneNumber")}
            />
          ) : (
            <p className="mb-3 bg-light p-2 rounded">
              {patient?.phoneNumber}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default Overview;
